module.exports = __webpack_public_path__ + "img/1f99a.c8a53e6.svg";